import { defineMessages } from '@edx/frontend-platform/i18n';

const messages = defineMessages({
  getStarted: {
    id: 'portal.components.carouselCourseCard.getStarted.link.text',
    defaultMessage: 'Get Started',
    description: 'Get Started button text',
  },
  learnMore: {
    id: 'portal.components.carouselCourseCard.learnMore.link.text',
    defaultMessage: 'Learn More',
    description: 'Learn More button text',
  },
  noDescription: {
    id: 'portal.components.carouselCourseCard.noDescription.text',
    defaultMessage: 'No description available',
    description: 'No description available text',
  },
  courseImageAlt: {
    id: 'portal.components.carouselCourseCard.courseImageAlt.text',
    defaultMessage: 'Course image',
    description: 'Course image alt text',
  },
});

export default messages;
